import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatPeriodoInformePensiones',
    standalone: false
})
export class FormatPeriodoInformePensionesPipe implements PipeTransform {

  transform(value: string): string {
    if (value?.length !== 6) return value; // Se mantiene la validación de longitud

    const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    const year = value.substring(0, 4); // Extrae los primeros 4 caracteres para el año: "2025"
    const month = Number.parseInt(value.substring(4, 6), 10); // Extrae los caracteres 5 y 6 para el mes: "05", y lo convierte a número: 5

    // Valida que el mes sea un número válido entre 1 y 12
    if (Number.isNaN(month) || month < 1 || month > 12) {
      return value; // Si el mes no es válido, devuelve el valor original
    }

    // Accede al array de meses. Como los arrays son base 0, se resta 1 al número del mes.
    const nombreMes = meses[month - 1]; // Para "05" (5), se accede a meses[4] que es "Mayo"

    return `${nombreMes} ${year}`; // Retorna "Mayo 2025"
  }

}
